import { isNil } from './isNil';

export const isDefined = (value: any): boolean => {
  return !isNil(value);
};
